import React, { useState } from "react";
import { NXAlertCircle } from "../../icons";
import AIButton from "../AIButton";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  label?: string;
  errorData?: Record<string, string[]>;
  labelProps?: Record<string, any>;
  helpText?: string;
  infoClassName?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  defaultValue?: any;
  AIConfig?: {
    fieldValue: string;
    fieldType: string;
  };
}

const InputField: React.FC<InputProps> = ({
  className,
  errorData,
  name,
  label,
  labelProps,
  helpText,
  infoClassName,
  onChange,
  defaultValue,
  AIConfig,
  ...props
}) => {
  const errorMessages = name && errorData && errorData[name] ? errorData[name] : [];
  const [inputValue, setInputValue] = useState("");


  const AIOnChangeHandler = (aivalue: string) => {
    if (onChange) {
      onChange({ target: { name, value: aivalue } } as React.ChangeEvent<HTMLInputElement>);
      setInputValue(aivalue);
    }
  }

  return (
    <div>
      {label && (
        <div className="flex items-center space-x-2 mb-1">
          <label htmlFor={name} {...labelProps} className="text-sm font-medium text-gray-700">
            {label}
          </label>
          <div className="relative group inline-block">
            {/* Icon */}
            <NXAlertCircle className={infoClassName ? infoClassName : "text-base-300"} />
            {/* Tooltip */}
            {helpText && (
              <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-max bg-black text-white text-xs rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity z-50">
                {helpText}
              </div>
            )}
          </div>
        </div>
      )}
      <div className="relative">
        <input
          {...props}
          onChange={onChange}
          name={name}
          defaultValue={inputValue || defaultValue}
          className={`block w-full border border-gray-300 rounded-md shadow-sm p-2 pr-10 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm ${
            className ? className : ""
          } ${errorMessages.length > 0 ? "border-red-500" : ""}`}
        />
        {AIConfig && (
          <div className="absolute inset-y-0 right-2 flex items-center">
            <AIButton
              fieldValue={AIConfig.fieldValue}
              fieldType={AIConfig.fieldType}
              onChange={AIOnChangeHandler}
            />
          </div>
        )}
      </div>
      {errorMessages.length > 0 && (
        <div className="text-red-600 text-sm mt-1">
          {errorMessages.map((error, index) => (
            <div key={index}>{error}</div>
          ))}
        </div>
      )}
    </div>
  );
};

export default InputField;
